import { render, staticRenderFns } from "./ManualCardView.vue?vue&type=template&id=285c194c"
import script from "./ManualCardView.vue?vue&type=script&lang=js"
export * from "./ManualCardView.vue?vue&type=script&lang=js"
import style0 from "./ManualCardView.vue?vue&type=style&index=0&id=285c194c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports